import { render, staticRenderFns } from "./TravelPlanSelectPage.vue?vue&type=template&id=272b48a5&scoped=true"
import script from "./TravelPlanSelectPage.vue?vue&type=script&lang=js"
export * from "./TravelPlanSelectPage.vue?vue&type=script&lang=js"
import style0 from "./TravelPlanSelectPage.vue?vue&type=style&index=0&id=272b48a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b48a5",
  null
  
)

export default component.exports